import React from 'react';
import SuccessIcon from '@atlaskit/icon/glyph/check-circle';
import ErrorIcon from '@atlaskit/icon/glyph/error';
import WarningIcon from '@atlaskit/icon/glyph/warning';
import { G300, R300, Y300 } from '@atlaskit/theme/colors';
const flagIconByType = {
  error: /*#__PURE__*/React.createElement(ErrorIcon, {
    label: "",
    primaryColor: `var(--ds-icon-danger, ${R300})`
  }),
  warning: /*#__PURE__*/React.createElement(WarningIcon, {
    label: "",
    primaryColor: `var(--ds-icon-warning, ${Y300})`
  })
};
const DefaultIcon = /*#__PURE__*/React.createElement(SuccessIcon, {
  label: "",
  primaryColor: `var(--ds-icon-success, ${G300})`
});
export const getTypeIcon = (type = 'normal') => flagIconByType[type] || DefaultIcon;